import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, NgZone } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { RecallModel } from '../../../models/recall.model';
import { PetService } from '../../../services/pet.service';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'ngx-work-recall',
  templateUrl: './recall.component.html',
  styles: [`
    .status-badge {
      padding: 4px 8px;
      border-radius: 4px;
      font-weight: 500;
      font-size: 0.875rem;
    }
  `]
})
export class RecallComponent implements OnInit, OnDestroy {

  private _pet_no: number;
  private recallUpdatedSub: Subscription;
  recall = false;
  notes = true;
  
  // Filter properties
  filterType: 'pet' | 'client' = 'pet';
  searchTerm: string = '';
  filteredRecalls: any[] = [];
  isLoading: boolean = false;

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    this.loadRecalls();
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone
  ) {
  }

  ngOnInit() {
    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
        }
      });

    // Listen to recall update notifications from the service
    this.recallUpdatedSub = this.petService.notify_RecallUpdatedObservable.subscribe(() => {
      this.loadRecalls();
    });
    
    // Cargar recalls inicialmente
    this.loadRecalls();
  }

  loadRecalls() {
    this.isLoading = true;
    
    if (this.filterType === 'pet') {
      this.petService.getRecallByClientOrPet(this.filterType, this.petService.current_pet_no).then(() => {
        // Usar NgZone para asegurar que el cambio se ejecute dentro de la zona de Angular
        this.ngZone.run(() => {
          this.filteredRecalls = [...(this.petService.pet_recalls || [])];
          this.isLoading = false;
        });
      });
    } else {
      this.petService.getRecallByClientOrPet(this.filterType, this.petService.current_client_no).then(() => {
        // Usar NgZone para asegurar que el cambio se ejecute dentro de la zona de Angular
        this.ngZone.run(() => {
          this.filteredRecalls = [...(this.petService.pet_recalls || [])];
          this.isLoading = false;
        });
      });
    }
  }

  setFilterType(type: 'pet' | 'client') {
    this.filterType = type;
    this.searchTerm = '';
    // No limpiar filteredRecalls aquí, dejar que loadRecalls() lo maneje
    this.loadRecalls();
  }

  add() {
    this.petService.pet_recall =  new RecallModel(this.petService.current_pet_no, this.petService.current_client_no, 0, '', '', '', '', '', '', '', '', '', '', false, '', '', 0, 0, '', '', '', '', '', '', 0, [],'N','Pending','', false);
    $('#modalNewPetRecall').modal('toggle')
    
  }

  edit(item) {
    this.petService.pet_recall = item;
    $('#modalNewPetRecall').modal('toggle')
  }

  onPetChange(event: any) {
    this.searchTerm = event.target.value;

    if (this.searchTerm === '') {
      this.filteredRecalls = [...(this.petService.pet_recalls || [])];
    } else {
      const petNo = parseInt(this.searchTerm, 10);
      this.filteredRecalls = (this.petService.pet_recalls || []).filter(recall => Number(recall.pet_no) === petNo);
    }
  }

  toggleEditStatus(item: any) {
    // Marcar el item como en edición
    if (item.recall_status != "D") {
    item.isEditing = true;
    
    // Enfocar el select después de que se renderice
    setTimeout(() => {
      const selectElement = document.querySelector('select[ng-reflect-model="' + item.recall_status + '"]') as HTMLSelectElement;
      if (selectElement) {
        selectElement.focus();
        selectElement.click();
      }
    }, 0);
    }
  }

  onStatusChange(item: any, newStatus: string) {
    // Si se selecciona 'D', mostrar confirmación ANTES de actualizar
      
      item.recall_status = newStatus;
      this.updateStatusInfo(item);
      // Guardar en el servidor
      this.finishEditStatus(item);
      // Cerrar el dropdown automáticamente
      this.closeDropdown(item);
    
  }

  closeDropdown(item: any) {
    // Cerrar el dropdown después de un breve delay
    setTimeout(() => {
      item.isEditing = false;
    }, 100);
  }

  getPreviousStatus(item: any): string {
    // Determinar el status anterior basado en el status actual
    if (item.recall_statusdesc === 'Pending') return 'N';
    if (item.recall_statusdesc === 'Attempted') return 'A';
    if (item.recall_statusdesc === 'Completed') return 'C';
    if (item.recall_statusdesc === 'Deleted') return 'D';
    return 'N'; // DefaultupdateStatus
  }

  getStatusClass(status: string): string {
    const statusMap = {
      'N': 'badge-warning', // Pending - warning (yellow)
      'A': 'badge-primary', // Attempted - primary (blue)
      'C': 'badge-success', // Completed - success (green)
      'D': 'badge-danger'   // Deleted - danger (red)
    };
    return statusMap[status] || 'badge-secondary';
  }

  updateStatusInfo(item: any) {
    // Actualizar la descripción del status basado en el valor seleccionado
    const statusMap = {
      'N': { desc: 'Pending', color: '#ffc107' }, // Bootstrap warning color
      'A': { desc: 'Attempted', color: '#007bff' }, // Bootstrap primary color
      'C': { desc: 'Completed', color: '#28a745' }, // Bootstrap success color
      'D': { desc: 'Deleted', color: '#dc3545' } // Bootstrap danger color
    };
    
    const statusInfo = statusMap[item.recall_status];
    if (statusInfo) {
      item.recall_statusdesc = statusInfo.desc;
      item.recall_statuscolor = statusInfo.color;
    }
    
    // Actualizar también en el array principal del servicio
    if (this.petService.pet_recalls) {
      const index = this.petService.pet_recalls.findIndex(recall => 
        recall.pet_no === item.pet_no && 
        recall.recall_sequence === item.recall_sequence
      );
      if (index !== -1) {
        this.petService.pet_recalls[index] = { ...item };
      }
    }
  }

  finishEditStatus(item: any) {
    // Finalizar la edición
    item.isEditing = false;
    
    // Guardar el cambio en el servidor
    this.petService.changeRecallStatus(item).then(() => {
      // Recargar la lista después de guardar
      this.loadRecalls();
      console.log('Status updated and list refreshed:', item.recall_status);
    }).catch((error) => {
      console.error('Error updating status:', error);
    });
  }

  cancelEditStatus(item: any) {
    // Cancelar la edición y restaurar el valor original
    item.isEditing = false;
    // Aquí podrías restaurar el valor original si es necesario
  }

  ngOnDestroy() {
    // Limpiar la suscripción cuando el componente se destruya
    if (this.recallUpdatedSub) {
      this.recallUpdatedSub.unsubscribe();
    }
  }

  delete(item: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!'
    }).then((result) => {
      if (result.isConfirmed) {
        item.recall_status = 'D';
        this.finishEditStatus(item);
      }
    });
  }
}
